import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CurrentUserService } from '@shared/services/current-user.service';

export const SuperAdminGuard: CanActivateFn = () => {
  const currentUserService = inject(CurrentUserService);
  const router = inject(Router);

  if (!currentUserService.isSuperAdmin()) {
    void router.navigate(['/']);
    return false;
  }
  return true;
};
